import { ActionReducer } from '@ngrx/store';
import * as configAction from './config.actions';
import * as action from './config.actions';
import { ConfigModel } from './config.model';

/**
 * Config reducer - manages config state.
 */
export const config: ActionReducer<ConfigModel> = (state: ConfigModel = null, {type, payload}: action.ResponseActions) => {
    switch (type) {
        case configAction.LOAD_SUCCESS:
            return payload;
        case configAction.LOAD_ERROR:
            return {error: payload};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.reducer.ts